import {listener} from "../../../../../modules/vegas/js/util";
import Catalog from "./catalog";
import {VGSidebar} from "vgsidebar";

listener('change-category', '#sidebar-catalog .categories-nav', (el, e) => {
	if (!document.querySelector('section.catalog #catalog-products')) {
		if (!e.detail.category.has_child) {
			location.href = e.detail.category.url;

			return;
		}
	}

	new Catalog(e.detail.category.url)
		.withHeaders({
			'V-View-Breadcrumbs': true,
			'V-View-Header': true,
			'V-View-Controls': true,
			'V-View-Filters': true,
			'X-View-Sidebar-Sorts': true,
		})
		.withResetFilters()
		.load((data) => {
			el.closest('.catalog')?.querySelector('.category-text')?.remove();
			window.scrollTo({ top: 0, behavior: 'smooth' });

			if (!e.detail.category.has_child) {
				VGSidebar.getInstance('#sidebar-catalog').hide();
			}
		});
});

listener('change-category', '.catalog .categories-nav', (el, e) => {
	new Catalog(e.detail.category.url)
		.withHeaders({
			'V-View-Breadcrumbs': true,
			'V-View-Header': true,
			'V-View-Controls': true,
			'V-View-Filters': true,
		})
		.withResetFilters()
		.load(() => {
			el.closest('.catalog')?.querySelector('.category-text')?.remove();

			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
});
